import React from "react";
import styled, { keyframes } from "styled-components";
import { useTranslation } from "react-i18next";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
`;

const Spinner = styled.div`
  width: 36px;
  height: 36px;
  border: 3px solid ${({ theme }) => theme.colors.border.subtle};
  border-top-color: ${({ theme }) => theme.colors.accent.primary};
  border-radius: ${({ theme }) => theme.radius.pill}px;
  animation: ${spin} 0.7s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    border-top-color: ${({ theme }) => theme.colors.border.subtle};
  }
`;

const SrOnly = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

/**
 * Neutral full-bleed loading state used by route guards while the async
 * session check is in flight. Rendering this (instead of redirecting) is what
 * prevents logged-in users from being bounced to /login on a hard refresh.
 */
const RouteFallback = () => {
  const { t } = useTranslation();
  return (
    <Wrap role="status" aria-live="polite">
      <Spinner aria-hidden="true" />
      <SrOnly>{t("common.loading", { defaultValue: "Loading…" })}</SrOnly>
    </Wrap>
  );
};

export default RouteFallback;
